import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import PrimaryNav from "./components/PrimaryNav";
import routes from "./routes";
import { useFormik } from "formik";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";

const Body = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("contact")}
      beforeCapture={scope => {
        scope.setTag("module", "contact");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

const Contact = props => {
  const formik = useFormik({
    initialValues: {},
  });
  return (
    <>
      <PrimaryNav formik={formik} />
      <Body {...props} formik={formik} />
    </>
  );
};

export default Contact;
